import { types } from 'mobx-state-tree';
import ShippingOption from '../ShippingOption';

const OrderShippingOption = types.compose(ShippingOption).named("OrderShippingOption");

export default OrderShippingOption;
